export enum ROUTES {
  INIT = '/',
  /* ONBOARDING */
  WELCOME = '/welcome',
  SURVEYS = '/surveys',
  AFTER_PAYMENT = '/after-payment',
  UNDER_AGE = '/under-age',
  GYMPASS_STATUS_4 = '/gympass-status-4',
  AFTER_SURVEY = '/after-survey',
  LANGUAGE_SELECTION = '/language-selection',
  /* PLANS */
  PLANS = '/plans',
  CHECKOUT = '/plans/checkout',
  MY_PLAN = '/my-plan/:cancel?',
  MODIFY_PLAN = '/modify-plan',
  CHECKOUT_MODIFY_PLAN = '/plans/checkout-modify-plan',
  CANCELLATION_SURVEY = '/cancellation-survey',
  /* AUTH */
  APP = '/app',
  LOGIN = '/login',
  VERIFY_EMAIL = '/login/:token',
  RECOVER_PASS = '/recover-password',
  RESET_PASS = '/reset-password/:token',
  SIGN_UP = '/sign-up',
  UNLOCK = '/unlock/:token',
  UPDATE_PASS = '/update-password',
  RESEND_CONFIRMATION = '/resend-email-verification',
  SEND_EMAIL = '/send-email',
  SEND_EMAIL_RESET = '/send-email-reset',
  COMPANY = '/company',
  EMPLOYEE = '/employee',
  /* WAITING CHAT */
  WAITING_SUPPORT = '/waiting-support',
  WAITING_THERAPIST = '/waiting-therapist',
  /* CHAT */
  CHAT_SUPPORT = '/chat-support',
  CHAT_THERAPIST = '/chat-therapist',
  MY_THERAPIST = '/my-therapist',

  FAVORITE_MESSAGES = '/favorite-messages',
  /* VIDEO_CALL */
  VIDEO_CALL = '/video-call/:id',
  VIDEO_CALL_ENDED = '/video-call-ended',

  /* USER */
  SCHEDULE_VIDEO_CALL = '/schedule-video-call',
  SCHEDULE_VIDEO_CALL_CAL_COM = '/schedule-booking-page/:rescheduleUid?',
  VIDEO_ROOM_CAL_COM = '/video-room/:id?',
  BOOKER_CAL_COM = '/booker-cal-com',
  CANCEL_CAL_COM = '/cancel-cal-com',
  /* SELF CARE */
  MY_DAY = '/my-day',
  JOURNAL = '/journal',
  STATISTICS = '/statistics',
  FAVORITES = '/favorites',
  MOOD_TRACKER = '/mood-tracker',
  MOOD_TRACKER_RECOMMENDATIONS = '/mood-tracker-recommendations/:id',
  /*Ryff Test*/
  RYFF = '/ryff',
  RYFF_END = RYFF + '/end',
  RYFF_RESULTS = '/ryff-results',
  RYFF_RESULTS_CATEGORY = '/ryff-results/category/:category/start-date/:startDate',
  /* MY ACCOUNT */
  MY_ACCOUNT = '/my-account',
  /*PAYMENT CARD EDIT*/
  PAYMENT_CARD_EDIT = '/payment-card-edit',
  /*TOOLS*/
  BREATH_ASSISTANT = '/breath-assistant/:id?',
  PODCAST = '/podcast/:id',
  VIDEO = '/video/:id',
  POST = '/post/:id',
  PILL = '/pill/:id',
  EXERCISE = '/exercise/:id',
  /* VITALY LOGIN GATEWAY*/
  VITALY_LOGIN_GATEWAY = '/vitaly-gateway',
  IFRAME_TESTER = '/iframe-tester',
}

export const isLimitedRoute = (route: ROUTES) => {
  const limitedRoutes = [
    ROUTES.AFTER_PAYMENT,
    ROUTES.PLANS,
    ROUTES.CHECKOUT,
    ROUTES.MY_PLAN,
    ROUTES.MODIFY_PLAN,
    ROUTES.CHECKOUT_MODIFY_PLAN,
    ROUTES.CANCELLATION_SURVEY,
    ROUTES.WAITING_SUPPORT,
    ROUTES.WAITING_THERAPIST,
    ROUTES.CHAT_SUPPORT,
    ROUTES.CHAT_THERAPIST,
    ROUTES.MY_THERAPIST,
    ROUTES.FAVORITE_MESSAGES,
    ROUTES.VIDEO_CALL,
    ROUTES.SCHEDULE_VIDEO_CALL,
    ROUTES.SCHEDULE_VIDEO_CALL_CAL_COM,
    ROUTES.PAYMENT_CARD_EDIT,
  ];
  return limitedRoutes.includes(route);
};

export const RouteCheckout = (planId: string, coupon?: string) => {
  let url = `${ROUTES.CHECKOUT}`;
  url += `?plan=${planId}`;

  if (coupon && coupon !== '') {
    url += `&coupon=${coupon}`;
  }

  return url;
};

export const RouteModifyPlanCheckout = (planId: string, coupon?: string) => {
  let url = `${ROUTES.CHECKOUT_MODIFY_PLAN}`;
  url += `?plan=${planId}`;

  if (coupon && coupon !== '') {
    url += `&coupon=${coupon}`;
  }

  return url;
};

export const RouteVideoCall = (conversationId: number) =>
  `${ROUTES.VIDEO_CALL.replace(':id', conversationId.toString())}`;

export const RoutePodcast = (id: number) =>
  `${ROUTES.PODCAST.replace(':id', id.toString())}`;

export const RouteVideo = (id: number) =>
  `${ROUTES.VIDEO.replace(':id', id.toString())}`;

export const RoutePost = (id: number) =>
  `${ROUTES.POST.replace(':id', id.toString())}`;

export const RoutePill = (id: number) =>
  `${ROUTES.PILL.replace(':id', id.toString())}`;

export const RouteExercise = (id: number) =>
  `${ROUTES.EXERCISE.replace(':id', id.toString())}`;

export const RouteMoodTrackerRecommendation = (id: number) =>
  `${ROUTES.MOOD_TRACKER_RECOMMENDATIONS.replace(':id', id.toString())}`;

export const BreathAssistant = (id?: number) =>
  `${ROUTES.BREATH_ASSISTANT.replace(':id', id ? id.toString() : '')}`;

export const MyPlan = (cancel?: boolean) =>
  `${ROUTES.MY_PLAN.replace(':cancel', cancel ? 'true' : '')}`;

export const RouteRyffResultsCategory = (category: string, startDate: string) =>
  `${ROUTES.RYFF_RESULTS_CATEGORY.replace(':category', category).replace(
    ':startDate',
    startDate,
  )}`;

export const RouteDetails = {
  [ROUTES.AFTER_PAYMENT]: {
    path: ROUTES.AFTER_PAYMENT,
    keyForTranslation: 'navigation.after_payment',
  },
  [ROUTES.CHECKOUT_MODIFY_PLAN]: {
    path: ROUTES.CHECKOUT_MODIFY_PLAN,
    keyForTranslation: 'navigation.my_plan',
  },

  [ROUTES.FAVORITE_MESSAGES]: {
    path: ROUTES.FAVORITE_MESSAGES,
    keyForTranslation: 'navigation.favorite_messages',
  },
  [ROUTES.FAVORITES]: {
    path: ROUTES.FAVORITES,
    keyForTranslation: 'navigation.self_care.favorites',
  },
  [ROUTES.JOURNAL]: {
    path: ROUTES.JOURNAL,
    keyForTranslation: 'navigation.self_care.diary',
  },

  [ROUTES.PLANS]: {path: ROUTES.PLANS, keyForTranslation: 'navigation.my_plan'},
  [ROUTES.MODIFY_PLAN]: {
    path: ROUTES.MODIFY_PLAN,
    keyForTranslation: 'navigation.my_plan',
  },
  [ROUTES.MOOD_TRACKER]: {
    path: ROUTES.MOOD_TRACKER,
    keyForTranslation: 'navigation.self_care.mood_tracker',
  },
  [ROUTES.MY_ACCOUNT]: {
    path: ROUTES.MY_DAY,
    keyForTranslation: 'navigation.my_account',
  },
  [ROUTES.MY_DAY]: {
    path: ROUTES.MY_DAY,
    keyForTranslation: 'navigation.self_care.self_care_home',
  },
  [ROUTES.MY_PLAN]: {
    path: ROUTES.MY_PLAN,
    keyForTranslation: 'navigation.my_plan',
  },
  [ROUTES.MY_THERAPIST]: {
    path: ROUTES.MY_THERAPIST,
    keyForTranslation: 'navigation.my_therapist',
  },
  [ROUTES.PAYMENT_CARD_EDIT]: {
    path: ROUTES.PAYMENT_CARD_EDIT,
    keyForTranslation: 'navigation.payment-card-edit',
  },
  [ROUTES.RYFF_RESULTS]: {
    path: ROUTES.RYFF_RESULTS,
    keyForTranslation: 'navigation.ryff_results',
  },
  [ROUTES.SCHEDULE_VIDEO_CALL]: {
    path: ROUTES.SCHEDULE_VIDEO_CALL,
    keyForTranslation: 'navigation.schedule_video_call',
  },
  [ROUTES.SCHEDULE_VIDEO_CALL_CAL_COM]: {
    path: ROUTES.SCHEDULE_VIDEO_CALL_CAL_COM,
    keyForTranslation: 'navigation.schedule_video_call_cal_com',
  },
  [ROUTES.STATISTICS]: {
    path: ROUTES.STATISTICS,
    keyForTranslation: 'navigation.self_care.statistics',
  },
  [ROUTES.VIDEO_CALL]: {
    path: ROUTES.VIDEO_CALL,
    keyForTranslation: 'navigation.video_call',
  },
};
